import { render, staticRenderFns } from "./ToolBar.vue?vue&type=template&id=0052cd47"
import script from "./ToolBar.vue?vue&type=script&lang=js"
export * from "./ToolBar.vue?vue&type=script&lang=js"
import style0 from "./ToolBar.vue?vue&type=style&index=0&id=0052cd47&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports